import React from "react";

// Components
import { Sidebar } from "./Sidebar";
import { UserModal } from "./UserModal";

export const Header = (props) => {
  return (
    <div className="header-container">
      <div className="header">
        <Sidebar activeItem={props.activeItem} />
        <div className="font-size-main">{props.title}</div>
        <UserModal />
      </div>
    </div>
  );
};
